<template>
  <div class="look-sensor">
    <div class="look-sensor-title">
      <div class="handle-wrapper" @click="backHistory">
        <div class="icon-font">&#xe612;</div>
        <a>返回</a>
      </div>
      <div class="look-sensor-item">传感器详情</div>
    </div>
    <div class="look-sensor-content">
      <div class="look-sensor-content-top">
        <div class="sensor-details">
          <div>传感器ID：{{ nodeInfo.nodeId }}</div>
          <div>传感器类型：{{ nodeInfo.nodeTypeName }}</div>
          <div>当前位置：{{ nodeInfo.gatherSite }}</div>
          <div>已用时间：{{ nodeInfo.monthDays }}</div>
        </div>
        <div class="sensor-history">养护历史</div>
      </div>
      <div class="detail">
        <div class="detail-box">
          <div class="loading-data" v-if="loading">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
          <div class="detail-nav">
            <div class="detail-item" style="width: 10%">序号</div>
            <div class="detail-item" style="width: 20%">采集位置</div>
            <div class="detail-item" style="width: 10%">操作类型</div>
            <div class="detail-item" style="width: 20%">制单时间</div>
            <div class="detail-item" style="width: 20%">操作人员</div>
            <div class="detail-item" style="width: 10%">备注</div>
          </div>
          <div class="detail-content">
            <div
              class="detail-list-wrapper"
              v-if="!loading && tableData.length > 0"
              v-for="(data, index) in tableData"
              :key="index"
            >
            
              <div class="detail-item" style="width: 10%">{{ index + 1 }}</div>
              <div class="detail-item" style="width: 20%">
                {{ data.gatherSite }}
              </div>
              <div class="detail-item" v-if="data.operationType === '01'" style="width: 10%">
                入垛
              </div>
              <div class="detail-item" v-else-if="data.operationType === '02'" style="width: 10%">
                解垛
              </div>
              <div class="detail-item" v-else style="width: 10%">
                修改
              </div>
              <div class="detail-item" style="width: 20%">
                {{ data.createTime }}
              </div>
              <div class="detail-item" style="width: 20%">
                {{ data.operator }}
              </div>
              <div class="detail-item" style="width: 20%">
                {{ data.remark }}
              </div>
            </div>
            <div class="none-data" v-if="!loading && tableData.length < 1">
              暂无数据
            </div>
          </div>
          <div class="page-wrapper" v-if="!loading && total > rows">
            <div class="page-wrapper-left">
              共{{ total }}条数据,共{{ Allpages }}页，每页显示{{
                rows
              }}条，当前第{{ page }}页
            </div>
            <div class="page-wrapper-right">
              <div class="page-btn" @click="firstPage">首页</div>
              <div class="page-btn" @click="previousPage">上一页</div>
              <div class="page-btn" @click="Tzpage">跳转至</div>
              <div class="page-btn">
                <input v-model="page" />
              </div>
              <div class="page-btn" @click="nextPage">下一页</div>
              <div class="page-btn" @click="lastPage">尾页</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="look-sensor-icon" src="../../../../assets/content-box.png" />
  </div>
</template>

<script>
import { nodeOperationLog } from "../../../../api/maintain";
import { renderTime } from "../../../../tools/methods";
import localforage from 'localforage'
export default {
  name: "TimeLookSensor",
  data() {
    return {
      loading: true,
      page: 1,
      rows: 6,
      total: "",
      // 总页数
      Allpages: 0,
      tableData: [],
      nodeId: "",
      nodeInfo: "",
    };
  },
  created() {
    this.nodeId = this.$route.query.nodeId;
    console.log(this.nodeId);
    this.handleSearch();
    let _this = this
    localforage.getItem('page_rem_core_timeLookSenor').then(res => {
      if (res) {
        _this.page=res
        _this.handleSearch()
      }
    })
  },
  methods: {
    handleSearch: function () {
      this.loading = true;
      let body = {
        page: this.page,
        rows: this.rows,
        nodeId: this.nodeId,
      };
      nodeOperationLog(body)
        .then((res) => {
          console.log(res);
          res.data.operaLog.rows.map((item) => {
            item.createTime = renderTime(item.createTime);
          });
          this.nodeInfo = res.data.nodeInfo;
          this.tableData = res.data.operaLog.rows;
          this.total = res.data.operaLog.total;
          // 计算总页数
          this.Allpages = Math.ceil(this.total / this.rows);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    backHistory: function () {
      this.$router.go(-1);
    },
    firstPage: function () {
      console.log("首页");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page = 1;
        localforage.setItem('page_rem_core_timeLookSenor', this.page)
        this.handleSearch();
      }
    },
    Tzpage: function () {
      console.log("跳转页面");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else if (this.page >= this.Allpages) {
        this.$message({
          message: "总页数为" + this.Allpages,
          type: "warning",
          center: "true",
          duration: "1000",
        });
        this.page = this.Allpages;
        localforage.setItem('page_rem_core_timeLookSenor', this.page)
        this.handleSearch();
      } else {
        localforage.setItem('page_rem_core_timeLookSenor', this.page)
        this.handleSearch();
      }
    },
    previousPage: function () {
      console.log("上一页");
      if (this.page < 2) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page--;
        localforage.setItem('page_rem_core_timeLookSenor', this.page)
        this.handleSearch();
      }
    },
    nextPage: function () {
      console.log("下一页");
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++;
        localforage.setItem('page_rem_core_timeLookSenor', this.page)
        this.handleSearch();
      } else {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
    },
    lastPage: function () {
      console.log("尾页");
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows);
        } else {
          this.page = parseInt(this.total / this.rows) + 1;
        }
        localforage.setItem('page_rem_core_timeLookSenor', this.page)
        this.handleSearch();
      }
    },
  },
};
</script>

<style scoped>
@import "Time.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/core/timeMonitoring/TimeLookSensor.vue